import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-bl-apply-now-pc.component.scss';
var FormItemBlApplyNowPc = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBlApplyNowPc, _super);
    function FormItemBlApplyNowPc(element) {
        return _super.call(this, element) || this;
    }
    FormItemBlApplyNowPc.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.wizard = this.element.querySelector(".form-container-wizard__wizard");
        this.buttonSubmit = Array.from(this.element.querySelectorAll(".js-blApplyPc__button--submit"));
        this.buttonCallMeBack = this.element.querySelector(".js-blApplyPc__button--cmb");
        // inputs
        this.creditCheck = this.element.querySelector("input[name=creditcheck]");
        this.bttDate = this.element.querySelector("input[name=date]");
        this.bttTime = this.element.querySelector("input[name=time]");
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displayMessage = this.form.querySelector(".form-container__message");
            this.displayMessageFail = this.form.querySelector(".form-container__message-fail");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayDeclined = this.form.querySelector(".form-container__declined");
            this.displaySuccessPc = this.form.querySelector(".form-container__success-pc");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector(".form-container__error");
            this.displayCmbFields = this.form.querySelector(".form-container__cmbfields");
        }
        this.entityType = this.element.querySelector(".js-apply-now-entity-type");
        this.bankType = this.element.querySelector(".js-bl-apply-now-pc__bank");
        this.loanAmount = this.element.querySelector(".js-bl-apply-now-pc__loan");
        this.businessReg = this.element.querySelector(".form__input--busReg");
        this.southAfricanIdField = this.element.querySelector(".form__input--saId");
        // buttons
        this.buttonConfirmCustomer = this.form.querySelector(".js-blApplyPc__button--confirmCustomer");
        if (this.entityType) {
            this.updateForm(this.entityType.value);
        }
    };
    FormItemBlApplyNowPc.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonSubmit) {
            this.buttonSubmit.map(function (item) { return item.addEventListener("click", function (event) {
                var _button = event.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                }
            }); });
        }
        if (this.buttonConfirmCustomer) {
            this.buttonConfirmCustomer.addEventListener("click", function (event) {
                var _confirmed = _this.displayMessage.querySelector("input[name=customer-confirm]:checked");
                if (_confirmed) {
                    if (_confirmed.value === "yes") {
                        _this.showDisplayView("fields");
                    }
                    else {
                        _this.showDisplayView("messageFail");
                        // Resize to display Business Current Account Cross-Sell
                        var formModal = _this.element.closest(".modal").querySelector(".modal__dialog--small");
                        if (formModal) {
                            formModal.classList.remove("modal__dialog--small");
                            formModal.classList.add("modal__dialog--large");
                        }
                    }
                }
            });
        }
        if (this.entityType) {
            this.entityType.addEventListener("change", function (event) {
                _this.updateForm(_this.entityType.value);
            });
        }
        if (this.bankType) {
            this.bankType.addEventListener("change", function (event) {
                _this.displayLoan(_this.bankType.value);
            });
        }
        // This adds slashes to the business registration number
        if (this.businessReg) {
            this.businessReg.addEventListener("input", function (event) {
                if ((event.inputType !== "deleteContentBackward") && (event.inputType !== "deleteContentForward")) {
                    var reg = event.target.value;
                    event.target.value = _this.validationService.formatBusinessReg(reg);
                }
            });
            this.businessReg.addEventListener("blur", function (event) {
                var reg = event.target.value;
                event.target.value = _this.validationService.formatExpression(reg);
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        if (this.buttonCallMeBack) {
            this.buttonCallMeBack.addEventListener("click", function (event) {
                _this.showCallMeBack(true);
            });
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (e) {
            // allow individual form items components to handle form reset
            if (_this.wizard) {
                var event_1 = new CustomEvent("custom_wizard_reset_event");
                _this.wizard.dispatchEvent(event_1);
            }
            var _creditCheck = _this.form.querySelector("input[name=creditcheck]");
            if (_creditCheck) {
                _creditCheck.value = "true";
            }
            var _fraudResponse = _this.form.querySelector("input[name=fraudResponse]");
            if (_fraudResponse) {
                _fraudResponse.value = "false";
            }
            var _amountResponse = _this.form.querySelector("input[name=amountResponse]");
            if (_amountResponse) {
                _amountResponse.value = "";
            }
            // This will reset step 2
            if (_this.entityType) {
                _this.updateForm(_this.entityType.value);
            }
            if (_this.bankType && _this.loanAmount) {
                _this.displayLoan(_this.bankType.value);
            }
            // Check if modal is custom, if not, resize
            var formModal = _this.element.closest(".modal").querySelector(".modal__dialog--large");
            if (formModal) {
                if (!formModal.closest(".form-container-related-links")) {
                    formModal.classList.remove("modal__dialog--large");
                    formModal.classList.add("modal__dialog--small");
                }
            }
            var _formName = _this.form.getAttribute("data-frmcontainer");
            _formName = _formName.replace(" cmb", "");
            _this.form.setAttribute("data-frmcontainer", _formName);
            var subjectMail = _this.form.querySelector("input[name=subject_mail]");
            var subject = _this.form.querySelector("input[name=subject]");
            if (subjectMail && subject) {
                subject.value = subjectMail.value;
            }
            _this.showDisplayView("");
        }, false);
    };
    FormItemBlApplyNowPc.prototype.updateForm = function (type) {
        if (this.southAfricanIdField) {
            var _group = this.southAfricanIdField.closest(".form__group");
            if (type !== "SOLE PROPRIETOR") {
                this.southAfricanIdField.classList.remove("form__input--required");
                _group.classList.add("form__group--hidden");
            }
            else {
                this.southAfricanIdField.classList.add("form__input--required");
                _group.classList.remove("form__group--hidden");
            }
        }
        if (this.businessReg) {
            var _group = this.businessReg.closest(".form__group ");
            if (type !== "SOLE PROPRIETOR") {
                this.businessReg.classList.add("form__input--required");
                _group.classList.remove("form__group--hidden");
            }
            else {
                this.businessReg.classList.remove("form__input--required");
                _group.classList.add("form__group--hidden");
            }
        }
        if (this.bankType && this.loanAmount) {
            this.displayLoan(this.bankType.value);
        }
    };
    FormItemBlApplyNowPc.prototype.displayLoan = function (type) {
        if (this.loanAmount && this.entityType) {
            var _group = this.loanAmount.closest(".form__group");
            if (type === "STANDARD BANK" || type === "") {
                this.loanAmount.classList.remove("form__input--required");
                _group.classList.add("form__group--hidden");
            }
            else {
                this.loanAmount.classList.add("form__input--required");
                _group.classList.remove("form__group--hidden");
            }
        }
    };
    FormItemBlApplyNowPc.prototype.showCallMeBack = function (pResetAnalytics) {
        if (pResetAnalytics === void 0) { pResetAnalytics = false; }
        this.displayCmbFields.classList.add("active");
        this.displayFields.classList.add("hidden");
        this.displayFields.classList.remove("active");
        this.displayCmbFields.classList.remove("hidden");
        this.displaySuccessPc.classList.add("hidden");
        this.displaySuccessPc.classList.remove("active");
        this.displaySuccess.classList.add("hidden");
        this.displaySuccess.classList.remove("active");
        this.creditCheck.value = "false";
        if (pResetAnalytics) {
            var _formName = this.form.getAttribute("data-frmcontainer");
            if (_formName !== "") {
                this.form.setAttribute("data-frmcontainer", _formName + " cmb");
            }
            this.analyticsService.dtmRestartForm();
        }
    };
    FormItemBlApplyNowPc.prototype.submitForm = function (form) {
        var _this = this;
        // additional containers
        var value = form.querySelector(".output-value");
        var name = Array.from(form.querySelectorAll(".form__success-container__firstname"));
        var contactNumber = Array.from(form.querySelectorAll(".form__success-container__contact"));
        var qualifiedAmount = form.querySelector(".form__success-container__approvedamount");
        // loader + hide form
        this.showDisplayView("loader");
        // hidden fields
        var description = form.querySelector("input[name=description]");
        var _email = form.querySelector("input[name=email]");
        var recipient = form.querySelector("input[name=recipient]");
        var _subjectMail = form.querySelector("input[name=subject_mail]");
        var subject = form.querySelector("input[name=subject]");
        var _product = form.querySelector("input[name=product]");
        var _redirect = form.querySelector("input[name=redirect]");
        // form fields
        var _firstName = form.querySelector("input[name=first-name]");
        var _surname = form.querySelector("input[name=surname]");
        var _contactNumber = form.querySelector("input[name=phone-number]");
        var _emailAddress = form.querySelector("input[name=email-address]");
        var _monthlyIncome = form.querySelector("input[name=monthly-income]");
        var _monthlyExpenses = form.querySelector("input[name=monthly-expenses]");
        var fraudConsent = form.querySelector("input[name=fraud-consent]");
        var _entityType = form.querySelector("select[name=entity-type]");
        var _businessName = form.querySelector("input[name=business-name]");
        var _idNumber = form.querySelector("input[name=sa-identity-number]");
        var _businessRegNumber = form.querySelector("input[name=business-reg-number]");
        var _businessIncome = form.querySelector("input[name=business-annual-income]");
        var _businessExpenses = form.querySelector("input[name=business-annual-expenses]");
        var _businessDescription = form.querySelector("textarea[name=business-description]");
        var _businessBank = form.querySelector("select[name=business-current-bank]");
        var _businessAccountNumber = form.querySelector("input[name=business-account-number]");
        var _loanAmount = form.querySelector("input[name=loan-amount]");
        var _purposeOfLoan = form.querySelector("textarea[name=purpose-of-loan]");
        var _creditCheck = form.querySelector("input[name=creditcheck]");
        var _fraudResponse = form.querySelector("input[name=fraudResponse]");
        var _amountResponse = form.querySelector("input[name=amountResponse]");
        var _postData = {
            'description': ((description) ? description.value : ""),
            'email': ((_emailAddress) ? _emailAddress.value : ""),
            'recipient': ((recipient) ? recipient.value : ""),
            'subject': ((subject) ? subject.value : ""),
            'product': ((_product) ? _product.value : ""),
            'redirect': ((_redirect) ? _redirect.value : ""),
            'first-name': ((_firstName) ? _firstName.value : ""),
            'firstName': ((_firstName) ? _firstName.value : ""),
            'surname': ((_surname) ? _surname.value : ""),
            'surName': ((_surname) ? _surname.value : ""),
            'formLocation': this.formLocationService.getLocation(),
            'phone-number': ((_contactNumber) ? _contactNumber.value : ""),
            'phoneNumber': ((_contactNumber) ? _contactNumber.value : ""),
            'email-address': ((_emailAddress) ? _emailAddress.value : ""),
            'monthlyincome': ((_monthlyIncome) ? _monthlyIncome.value : ""),
            'monthlyexpenses': ((_monthlyExpenses) ? _monthlyExpenses.value : ""),
            'fraud-consent': ((fraudConsent) ? fraudConsent.value : ""),
            'fraudConsent': ((fraudConsent) ? fraudConsent.value : ""),
            'entity-type': ((_entityType) ? _entityType.value : ""),
            'business-name': ((_businessName) ? _businessName.value : ""),
            'custorgname': ((_businessName) ? _businessName.value : ""),
            'saId': ((_idNumber) ? _idNumber.value : ""),
            'business-reg-number': ((_businessRegNumber) ? _businessRegNumber.value : ""),
            'annualTurnOver': ((_businessIncome) ? _businessIncome.value : ""),
            'annualexpneses': ((_businessExpenses) ? _businessExpenses.value : ""),
            'business-description': ((_businessDescription) ? _businessDescription.value : ""),
            'business-current-bank': ((_businessBank) ? _businessBank.value : ""),
            'business-account-number': ((_businessAccountNumber) ? _businessAccountNumber.value : ""),
            'loan-amount': ((_loanAmount) ? _loanAmount.value : ""),
            'purpose-of-loan': ((_purposeOfLoan) ? _purposeOfLoan.value : ""),
            'source': this.formsService.isMobile(),
            'creditcheck': _creditCheck.value,
            'timeToCall': "anytime",
            'fraud': _fraudResponse.value,
            'amount': _amountResponse.value
        };
        if (_creditCheck.value === "false") {
            var date = form.querySelector("input[name=date]");
            var time = form.querySelector("select[name=time]");
            if (time && date) {
                if (time.value !== "Anytime") {
                    _postData.timeToCall = date.value + " " + time.value;
                }
            }
        }
        if (this.entityType.value === "SOLE PROPRIETOR" && _businessBank.value === "STANDARD BANK") {
            var url_1 = this.baseUrl + "/services/brcpService.jsp";
            delete (_postData["description"]);
            delete (_postData["product"]);
            delete (_postData["redirect"]);
            delete (_postData["first-name"]);
            delete (_postData["surname"]);
            delete (_postData["phone-number"]);
            delete (_postData["email-address"]);
            delete (_postData["fraud-consent"]);
            delete (_postData["entity-type"]);
            delete (_postData["business-name"]);
            delete (_postData["business-reg-number"]);
            delete (_postData["business-description"]);
            delete (_postData["business-current-bank"]);
            delete (_postData["business-account-number"]);
            delete (_postData["purpose-of-loan"]);
            _postData.monthlyincome = ((_monthlyIncome) ? (_monthlyIncome.value * 12) : "");
            _postData.monthlyexpenses = ((_monthlyExpenses) ? (_monthlyExpenses.value * 12) : "");
            this.formsService.postForm(url_1, this.http.serialiseObject(_postData)).then(function (pResponse) {
                var _pResponse = pResponse.data;
                if (_pResponse === "invalid") {
                    _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url_1);
                    _this.showDisplayView("error");
                }
                else if (!_pResponse.error && (_pResponse.amount || _pResponse.code || _pResponse.leadID)) {
                    if (_pResponse.amount) {
                        _this.analyticsService.dtmFormComplete("complete", "true");
                        _amountResponse.value = _pResponse.amount;
                        if (_creditCheck.value === "true") {
                            _this.showDisplayView("successPc");
                        }
                        else {
                            _this.showDisplayView("success");
                        }
                        name.map(function (_item) {
                            _item.innerHTML = _firstName.value;
                        });
                        contactNumber.map(function (_item) {
                            _item.innerHTML = _contactNumber.value;
                        });
                        value.innerHTML = "R " + _pResponse.amount;
                        if (qualifiedAmount) {
                            qualifiedAmount.innerHTML = _pResponse.amount;
                        }
                        subject.value = "Your loan application is successful";
                        _creditCheck.value = "false";
                    }
                    else if (_pResponse.code) {
                        _this.analyticsService.dtmFormComplete("complete", _pResponse.code);
                        var _tmp = _this.formsService.powerCurveErrors.find(function (item) {
                            return item.code = _pResponse.code;
                        });
                        if (_tmp) {
                            _this.analyticsService.dtmRecordSiteError(_tmp.message);
                        }
                        else {
                            _this.analyticsService.dtmRecordSiteError("Access Quote Declined");
                        }
                        _this.showDisplayView("declined");
                        _creditCheck.value = "false";
                        subject.value = _subjectMail.value;
                    }
                    else if (_pResponse.fraud) {
                        _this.analyticsService.dtmFormComplete("complete", _pResponse.fraud);
                        _fraudResponse.value = _pResponse.fraud;
                        _this.showDisplayView("declined");
                        _creditCheck.value = "false";
                        subject.value = "Your loan application is in review";
                    }
                    else if (_pResponse.leadID) {
                        _this.analyticsService.dtmFormComplete("complete", _pResponse.leadID);
                        _this.showDisplayView("success");
                        _creditCheck.value = "false";
                        subject.value = _subjectMail.value;
                    }
                    else {
                        _this.analyticsService.dtmFormComplete("complete", _pResponse.code);
                        var _tmp = _this.formsService.powerCurveErrors.find(function (item) {
                            return item.code = _pResponse.code;
                        });
                        if (_tmp) {
                            _this.analyticsService.dtmRecordSiteError(_tmp.message);
                        }
                        else {
                            _this.analyticsService.dtmRecordSiteError("Access Quote Declined");
                        }
                        _this.showDisplayView("declined");
                    }
                }
                else {
                    _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url_1);
                    _this.showDisplayView("error");
                }
            }).catch(function (response) {
                // service failed
                _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occurred|" + url_1);
                _this.showDisplayView("message");
            });
        }
        else {
            var url_2 = this.baseUrl + "/services/genericform.jsp";
            delete (_postData["firstName"]);
            delete (_postData["surname"]);
            delete (_postData["phoneNumber"]);
            delete (_postData["fraudConsent"]);
            delete (_postData["custorgname"]);
            delete (_postData["creditcheck"]);
            _postData.subject = (_subjectMail ? _subjectMail.value : "");
            _postData.email = (_email ? _email.value : "");
            if (_creditCheck.value === "true") {
                this.showDisplayView("successPc");
                _creditCheck.value = "false";
                name.map(function (_item) {
                    _item.innerHTML = _firstName.value;
                });
            }
            else {
                this.formsService.postForm(url_2, this.http.serialiseObject(_postData)).then(function (pResponse) {
                    var _response = pResponse.data;
                    if (_response.toString().includes("invalid")) {
                        _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url_2);
                        _this.showDisplayView("error");
                    }
                    else {
                        name.map(function (_item) {
                            _item.innerHTML = _firstName.value;
                        });
                        _this.analyticsService.dtmFormComplete("complete", _response.code);
                        _this.showDisplayView("success");
                    }
                }).catch(function (pResponse) {
                    // service failed
                    _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occurred|" + url_2);
                    _this.showDisplayView("error");
                });
            }
        }
    };
    FormItemBlApplyNowPc.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayMessage.classList.add("hidden");
        this.displayMessageFail.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displaySuccessPc.classList.add("hidden");
        this.displayDeclined.classList.add("hidden");
        this.displayError.classList.add("hidden");
        this.displayCmbFields.classList.add("hidden");
        switch (pDisplay) {
            case "message":
                this.displayMessage.classList.remove("hidden");
                break;
            case "messageFail":
                this.displayMessageFail.classList.remove("hidden");
                break;
            case "fields":
                this.displayFields.classList.remove("hidden");
                break;
            case "cmb":
                this.displayCmbFields.classList.remove("hidden");
                break;
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "successPc":
                this.displaySuccessPc.classList.remove("hidden");
                break;
            case "declined":
                this.displayDeclined.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayError.classList.remove("hidden");
                break;
            default:
                this.displayMessage.classList.remove("hidden");
                break;
        }
    };
    return FormItemBlApplyNowPc;
}(Base));
export { FormItemBlApplyNowPc };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-bl-apply-now-pc/form-item-bl-apply-now-pc.component.ts
// module id = 833
// module chunks = 0